

import { apiFetcher } from "@/api/api"
import { useCacheSWR } from "@/api/swrCache"
import useSWRMutation from 'swr/mutation'

export function useFeedbackList(params) {
    const fetcher = () => {
        return apiFetcher(
            {
                path: '/site/api/v1/user/feedback/getFeedBackList',
                type: 'post'
            },
            {
                arg: params
            }
        )
    }
    const result = useCacheSWR('useFeedbackList' + JSON.stringify(params), fetcher, {
        dedupingInterval: 60 * 60 * 1000,
        author: true
    })
    const data = result.data?.data
    return {
        ...result,
        data: data
    }
}


/**
 * 获取反馈信息
 */
export function useGetFeedbackInfo(id) {
    const fetcherFuc = () => {
        return apiFetcher(
            {
                path: '/site/api/v1/user/feedback/getFeedbackInfo',
                type: 'post'
            },
            {
                arg: {
                    id
                }
            }
        )
    }
    const result = useCacheSWR('useGetFeedbackInfo' + id, id ? fetcherFuc : null, {
        dedupingInterval: 10 * 1000,
        author: true
    })
    const data = result?.data?.data
    return {
        ...result,
        details: data
    }
}

// 删除意见反馈
export function useDeleteFeedback() {
    const params = {
        path: '/site/api/v1/user/feedback/delFeedback',
        type: 'post'
    }
    return useSWRMutation(params, (params, arg: { arg: any }) => {
        return apiFetcher<any>(params, { ...arg })
    })
}

